import { Performance } from '../shared/Performance'
import { windowObject } from '../windowObject'
import { Log } from './logger/Log'

export type Timings = {
  [event: string]: number
}

export enum PerfMetricEvents {
  ClientStartup = 'ClientStartup',
  UserObtained = 'UserObtained',
  Rendered = 'Rendered',
  ShellRendered = 'ShellRendered',
  RedirectedToLogin = 'RedirectedToLogin',
}

const loadEvent = 'LoadingingIndicatorRendered'

/**
 * A place to store several key timings during the client start-up sequence
 * to measure our overall client performance and determine if we are improving
 * or regressing our start time for our users.
 */

export class ClientPerfMetrics {
  clientTimings: Timings

  perfMetricStart: number

  public static create(): ClientPerfMetrics {
    const perfMetrics = new ClientPerfMetrics(windowObject.loadTiming())
    Performance.start(PerfMetricEvents.ClientStartup)
    perfMetrics.addMeasurement(PerfMetricEvents.ClientStartup)
    return perfMetrics
  }

  private constructor(splashTiming: number) {
    const t: PerformanceTiming = performance.timing

    this.clientTimings = {}

    if (t.navigationStart) {
      this.perfMetricStart = t.navigationStart
      this.clientTimings[loadEvent] = splashTiming - t.navigationStart
    } else {
      this.perfMetricStart = Date.now()
    }
  }

  addMeasurement = (eventName: PerfMetricEvents) => {
    this.clientTimings[eventName] = Date.now() - this.perfMetricStart
    Performance.endAndMeasure(eventName, PerfMetricEvents.ClientStartup)
  }

  log = () => {
    Log.logger.logReportData('StickyNotesClientPerformance', false /* isCriticalEvent */,  this.clientTimings)
  }
}
